import { dataProps, featureItemProps, itemListProps } from './properties'

export const setEStoreHomePageList = (state, payload) => {
    state.list = payload
}

export const setEStoreHomePageData = (state, payload) => {
    state.props = payload

    let key = 0
    state.props.slider_items.forEach(element => {
        element.key = key
        key ++
    })

    key = 0
    state.props.feature_list_items.forEach(element => {
        element.key = key
        key ++
        let key1 = 0
        element.item_list.forEach(el => {
            el.key = key1
            key1 ++ 
        })
    })

} 

/* SLIDER ITEMS */
export const addEStoreHomePageDataSliderItem = state => {
    state.props.slider_items.push(JSON.parse(JSON.stringify(itemListProps)))

    let key = 0
    state.props.slider_items.forEach(element => {
        element.key = key
        key ++
    })
} 

export const removeEStoreHomePageDataSliderItem = (state, payload) => {
    let key = 0

    state.props.slider_items.splice(payload, 1)

    if(state.props.slider_items.length === 0) {
        state.props.slider_items = [JSON.parse(JSON.stringify(itemListProps))]
    }

    state.props.slider_items.forEach(element => {
        element.key = key
        key ++
    })
} 
/* END SLIDER ITEMS */

/* FEATURED ITEMS */
export const addEStoreHomePageDataFeaturedItem = state => {
    state.props.feature_list_items.push(JSON.parse(JSON.stringify(featureItemProps)))

    let key = 0
    state.props.feature_list_items.forEach(element => {
        element.key = key
        key ++
    })
} 

export const removeEStoreHomePageDataFeaturedItem = (state, payload) => {
    let key = 0

    state.props.feature_list_items.splice(payload, 1)

    if(state.props.feature_list_items.length === 0) {
        state.props.feature_list_items = [JSON.parse(JSON.stringify(featureItemProps))]
    }

    state.props.feature_list_items.forEach(element => {
        element.key = key
        key ++
    })
} 
/* END FEATURED ITEMS */

/* FEATURED ITEMS SKU LIST */
export const addEStoreHomePageDataFeaturedItemSKU = (state, payload) => {
    console.log(JSON.stringify(payload))
    state.props.feature_list_items[payload.parentKey].item_list.push(JSON.parse(JSON.stringify(itemListProps)))

    let key = 0
    state.props.feature_list_items[payload.parentKey].item_list.forEach(element => {
        element.key = key
        key ++
    })
} 

export const removeEStoreHomePageDataFeaturedItemSKU = (state, payload) => {
    let key = 0
    state.props.feature_list_items[payload.parentKey].item_list.splice(payload.key, 1)

    state.props.feature_list_items[payload.parentKey].item_list.forEach(element => {
        element.key = key
        key ++
    })
}
/* END FEATURED ITEMS SKU LIST */

export const resetEStoreHomePageData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreHomePage/mutations.js